module.exports = __webpack_public_path__ + "img/Thank-you-for-REGISTERATION-th.55b91d3.png";